import PriceComparisonReportActions from './actions';

const INITIAL_STATE = {
  data: {},
  dataSelling: {},
  dataPurchasing: {},
  isProcessing: false,
  isError: false,
  errorMessage: [],
  form:{},
  isNewRecord:false,
  showModal:false,
  helperPriceComparisonReport:null,
  timeline:null,
  details:null,
  loadingDetails:false,
  printPriceComparison:null,
  printSelling:null,
  printPurchasing:null,
  isProcessingSelling:false,
  isProcessingPurchasing:false
};

function PriceComparisonReportReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case PriceComparisonReportActions.RESET_DATA:
      return INITIAL_STATE;
    case PriceComparisonReportActions.NEW_DATA:
      return { ...state, isProcessing: false,single:null, form:INITIAL_STATE.form,isNewRecord:true,showModal:true};
    case PriceComparisonReportActions.PROCESS_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: true, isError: false,isSuccess:false};
    case PriceComparisonReportActions.GET_HELPER_PRICECOMPARISONREPORT:
        return { 
          ...state,
          isProcessing: false, 
          helperPriceComparisonReport: action.payload 
        };
      case PriceComparisonReportActions.GET_DATA:
        return { 
          ...state,
          isError: false,
          isProcessing: true, 
      };
      case PriceComparisonReportActions.SET_DATA_SELLING:
        return { 
          ...state,
          isProcessing: false, 
          isError: false,
          dataSelling: action.payload 
        };
      case PriceComparisonReportActions.SET_DATA_PURCHASING:
        return { 
          ...state,
          isProcessing: false, 
          isError: false,
          dataPurchasing: action.payload 
        };
      case PriceComparisonReportActions.ERROR_DATA:
          return { 
            ...state, errorInternal:false, 
            isError: true,onSubmit:false,  
            errorMessage: action.payload,
            isProcessing:false 
        };
      case PriceComparisonReportActions.LOADED_DETAILS:
        return { 
          ...state,
          details: action.payload, 
          loadingDetails: false
        };
      case PriceComparisonReportActions.LOADING_DETAILS:
        return { 
          ...state,
          details: null, 
          loadingDetails: true
        };
      case PriceComparisonReportActions.BEFORE_PRINT_PRICECOMPARISON_SELLING:
            return { ...state,errorInternal:false,  isError: false,isSuccess:false,onSubmit:false,printSelling:null,isProcessingSelling:true};  
            
      case PriceComparisonReportActions.BEFORE_PRINT_PRICECOMPARISON_PURCHASING:
            return { ...state,errorInternal:false,  isError: false,isSuccess:false,onSubmit:false,printPurchasing:null,isProcessingPurchasing:true};

      case PriceComparisonReportActions.PRINT_PRICECOMPARISON_SELLING:
        return { ...state,errorInternal:false,  isError: false,isSuccess:false,onSubmit:false,printSelling:action.payload,isProcessingSelling:false};     
        
      case PriceComparisonReportActions.PRINT_PRICECOMPARISON_PURCHASING:
        return { ...state,errorInternal:false,  isError: false,isSuccess:false,onSubmit:false,printPurchasing:action.payload,isProcessingPurchasing:false};     
    default:
      return state;
    }
}


export default PriceComparisonReportReducer;
